export default "__VITE_ASSET__BrObVyxl__"